import { Card } from "../../styled-components/Card";
import DeleteIcon from "../../../assets/components/DeleteIcon";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ClientContact from "../../../model/ClientContact";
import { useTheme } from "styled-components";
import Select from "@mui/material/Select";
import ClientContactType from "../../../model/ClientContactType";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { current } from "@reduxjs/toolkit";

interface ClientContactEntryProps {
    contact: ClientContact;
    contacts: ClientContact[];
    handleChange: (clientContacts: ClientContact[]) => void;
}

const ClientContactEntry: React.FC<ClientContactEntryProps> = ({contact, contacts, handleChange}) => {
    const theme = useTheme();
    const contactTypes = Object.keys(ClientContactType).filter(key => isNaN(Number(key)));
    return <Card style={{ padding: "1rem"}}>
                <Box display="flex" flexDirection="column" gap={3}>
                    <Box display="flex" flexDirection={"row"} gap={3} justifyContent={"space-between"} alignItems={"center"}>
                        <Box display="flex" flexDirection={"row"} gap={3}>
                            <TextField
                                label="Name"
                                value={contact.name}
                                error={contact.name.length === 0}
                                required
                                onChange={(e) => {
                                    handleChange(contacts.map(c => c.clientContactId === contact.clientContactId ? { ...c, name: e.currentTarget.value } : c))
                                }}
                            />
                        <FormControl>
                            <InputLabel id="contact-type-label">Type</InputLabel>
                            <Select
                                labelId="contact-type-label"
                                id="contact-type-select"
                                value={contact.type as number}
                                label="Type"
                                onChange={(e) => {                                    
                                    handleChange(contacts.map(c => c.clientContactId === contact.clientContactId ? { ...c, type: e.target.value as number} : c))
                                }}
                            >
                                {contactTypes.map((key, index) => {
                                    return <MenuItem key={key} value={index}>{contactTypes[index]}</MenuItem>
                                })}
                            </Select>
                        </FormControl>                                                         
                        </Box>

                        <IconButton sx={{ width: "2.5rem", height: "2.5rem"}} onClick={() => handleChange(contacts.filter(c => c.clientContactId !== contact.clientContactId))}>
                                <DeleteIcon fill={theme.palette.error.main}/>
                        </IconButton>
                    </Box>
                    <Box display="flex" flexDirection={"row"} gap={3} justifyContent={"space-between"} alignItems={"center"}>
                            <TextField
                                className="w-100"
                                label="Email"
                                value={contact.email}
                                onChange={(e) => {
                                    handleChange(contacts.map(c => c.clientContactId === contact.clientContactId ? { ...c, email: e.currentTarget.value } : c))
                                }}
                            />
                            <TextField
                                className="w-100"
                                label="Phone"
                                value={contact.phone}
                                onChange={(e) => {
                                    handleChange(contacts.map(c => c.clientContactId === contact.clientContactId ? { ...c, phone: e.currentTarget.value } : c))                                    
                                }}
                            />
                            <TextField
                                className="w-100"
                                label="Mobile"
                                value={contact.mobile}
                                onChange={(e) => {
                                    handleChange(contacts.map(c => c.clientContactId === contact.clientContactId ? { ...c, mobile: e.currentTarget.value } : c))                                     
                                }}
                            />
                    </Box>
                </Box>
            </Card>
}

export default ClientContactEntry;
